import React from 'react';
import { Box, Container, Typography, Paper, Grid, Button } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SelfImprovementOutlinedIcon from '@mui/icons-material/SelfImprovementOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import CYJHero from '../components/CYJHero';
import WhatIsCYJ from '../components/WhatIsCYJ';
import WhoIsFor from '../components/WhoIsFor';
import WhatYoullFeel from '../components/WhatYoullFeel';
import WhatsIncluded from '../components/WhatsIncluded';
import Assessments from '../components/Assessments';
import WhyCYJWorks from '../components/WhyCYJWorks';
import HowToUse from '../components/HowToUse';
import NoteFromSara from '../components/NoteFromSara';
import TestimonialSection from '../components/TestimonialSection';

const Section = ({ title, children, bgcolor = 'background.default', sx = {} }) => (
  <Box sx={{ py: 6, bgcolor, width: '100%', ...sx }}>
    <Container maxWidth={false} sx={{ width: '100%' }}>
      <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, bgcolor: 'white' }}>
        {title && (
          <Typography variant="h3" fontWeight={400} sx={{ mb: 3, fontSize: { xs: 26, md: 34 }, textAlign: 'center' }}>
            <strong>{title}</strong>
          </Typography>
        )}
        {children}
      </Paper>
    </Container>
  </Box>
);

const SelfDiscovery = () => {
  return (
    <Box sx={{ bgcolor: 'background.default', color: 'text.primary' }}>
      <Section title="Craft Your Journey (CYJ) – Self-Discovery Package" bgcolor="custom.beige" sx={{ mb: { xs: 3, md: 5 } }}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" sx={{ color: 'custom.blue', mb: 2, fontWeight: 400 }}>
              A gentle, science-based journey back to you.
            </Typography>
            <Typography sx={{ mb: 2, fontSize: { xs: 17, md: 19 }, color: 'text.secondary' }}>
              Have you ever looked at your life and thought…
            </Typography>
            <Box sx={{ maxWidth: 600, mb: 2 }}>
              <Typography sx={{ fontStyle: 'italic', color: 'text.primary', mb: 1 }}>
                “I’m grateful… but why do I still feel heavy?”<br/>
                “I do so much… but I’m not sure who I am anymore.”<br/>
                “I want calm, clarity, and direction… but my mind feels crowded.”
              </Typography>
            </Box>
            <Typography sx={{ mb: 2, color: 'text.secondary' }}>
              Sometimes it’s not that your life is wrong.<br/>
              It’s that you’ve been living it while carrying:
            </Typography>
            <Box sx={{ maxWidth: 500, mb: 2 }}>
              <Box component="ul" sx={{ color: '#555', fontSize: '1.05rem', m: 0, pl: 3, listStyle: 'none' }}>
                <Box component="li" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <span style={{ marginRight: 8 }}><InfoOutlinedIcon sx={{ fontSize: 32, color: 'primary.main' }} /></span> expectations you didn’t choose
                </Box>
                <Box component="li" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <span style={{ marginRight: 8 }}><SentimentSatisfiedAltOutlinedIcon sx={{ fontSize: 32, color: 'custom.red' }} /></span> fears you never healed
                </Box>
                <Box component="li" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <span style={{ marginRight: 8 }}><SelfImprovementOutlinedIcon sx={{ fontSize: 32, color: 'custom.blue' }} /></span> roles that slowly replaced your identity
                </Box>
                <Box component="li" sx={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: 8 }}><Diversity3OutlinedIcon sx={{ fontSize: 32, color: 'custom.yellow' }} /></span> and society’s noise that convinced you to “keep going” even when you feel lost inside
                </Box>
              </Box>
            </Box>
            <Typography sx={{ mb: 2, color: 'text.secondary' }}>
              I created Craft Your Journey for that exact moment.<br/>
              Not to “fix” you — because you’re not broken.<br/>
              But to help you come back to yourself with clarity, compassion, and a guided plan.
            </Typography>
            <Typography variant="h4" fontWeight={700} sx={{ mb: 1 }}>
              Total Price: $37
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{}}
              href="/self-discovery/checkout"
            >
              Begin Your Checkout
            </Button>
          </Grid>
          <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'right' }}}>
            <Box component="img" src="/assets/sara-self-discovery.jpeg" alt="Self Discovery" sx={{ width: { xs: '90%', md: 600 }, borderRadius: 2, boxShadow: 3 }} />
          </Grid>
        </Grid>
      </Section>

      {/* <CYJHero /> */}
      <Box sx={{ mb: { xs: 3, md: 5 } }} />
      <WhatIsCYJ />
      <Box sx={{ mb: { xs: 3, md: 5 } }} />
      <WhoIsFor />
      <Box sx={{ mb: { xs: 3, md: 5 } }} />
      <WhatYoullFeel />
      <Box sx={{ mb: { xs: 3, md: 5 } }} />
      <WhatsIncluded />
      <Box sx={{ mb: { xs: 3, md: 5 } }} />
      <Assessments />
      <Box sx={{ mb: { xs: 3, md: 5 } }} />
      <WhyCYJWorks />
      <Box sx={{ mb: { xs: 3, md: 5 } }} />
      <HowToUse />
      <Box sx={{ mb: { xs: 3, md: 5 } }} />
        <TestimonialSection />
      <NoteFromSara />

      <Box sx={{ mb: { xs: 3, md: 5 } }} />
              <Section title="Ready to Begin?" bgcolor="custom.beige">
            <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} md={8}>
                    <Typography fontFamily="inherit" sx={{ mb: 2 }}>
                        Re-discover yourself with clarity, compassion, and science. Start living a life that reflects your values, your strengths, and your inner truth.
                    </Typography>
                    <Typography fontFamily="inherit" sx={{ mb: 2 }}>
                        Package Price: <strong>$37</strong> — delivered digitally with instant confirmation.
                    </Typography>
                    <Button variant="contained" color="primary" size="large" sx={{ borderRadius: 2 }} href="/self-discovery/checkout">
                        Complete Purchase
                    </Button>
                </Grid>
            </Grid>
        </Section>
    </Box>
  );
};

export default SelfDiscovery;
